// Scripts/main.ts
// Punto de entrada global de la aplicación.
// Importa dinámicamente los scripts modulares según la página actual.

import "./Components/button.js";
import "./Components/input.js";
import "./Components/file-input.js";
import "./Components/checkbox.js";
import "./Components/select.js";
import "./Components/modal.js";
import "./Components/navbar.js";
import "./Components/accordion.js";
import "./Components/cookie-banner.js";
import "./Pages/winners.js";

// Carga dinámica de scripts por página
const currentPath = location.pathname.toLowerCase();

if (currentPath.includes("/registeratun")) {
  import("./Pages/registerAtun.js");
} else if (currentPath.includes("/registeraceite")) {
  import("./Pages/registerAceite.js");
} else if (currentPath.includes("/help")) {
  import("./Pages/help.js");
} else if (currentPath.includes("/prizes")) {
  import("./Pages/prizes.js");
} else {
  import("./Pages/index.js");
}
